// extracted by mini-css-extract-plugin
export default {"grid":"CardGrid_grid__sx6ju"};